module.exports = __webpack_public_path__ + "8d3cc14fec1cb9c0203f916adab91cee.ttf";